import { useEffect, useState, useCallback, useRef } from 'react';

const slides = [
  {
    seq: 'hero-eikou-s04',
    imageUrl: 'https://public.readdy.ai/ai/img_res/cb93f5e7f9540d3721eacdc642f870fc.jpg',
    tag: '高品質仕上げ',
    heading: <><span className="text-[#E8A87C]">信頼の施工</span>で未来を創る</>,
    sub: '株式会社永恒は、内装工事の専門企業として、壁紙・ボード・LGS工事を通じて高品質な空間づくりを支え続けています。',
    primary: { label: '会社概要', href: '#about' },
    secondary: { label: 'お問い合わせ', href: '#contact' },
    tint: 'bg-gradient-to-br from-red-950/40 via-orange-950/20 to-transparent',
    accent: 'bg-gradient-to-r from-black/80 via-red-950/40 to-black/20',
    tagColor: '#E8A87C',
    tagLine: '#C07840',
    btnPrimary: 'bg-[#C07840] hover:bg-[#A06030]',
    btnSecondary: 'border-[#E8A87C]/70 hover:bg-[#E8A87C]/10 text-[#F5C8A0]',
    accentText: 'text-[#E8A87C]',
  },
  {
    seq: 'hero-eikou-s01',
    imageUrl: 'https://public.readdy.ai/ai/img_res/edited_d9728d3d1024e83c641a9eb39dbf8704_7dfe5eda.jpg',
    tag: '壁紙クロス工事',
    heading: <>職人の技が宿る<br /><span className="text-[#D4AF37]">美しい壁面</span>を<br />あなたの空間へ</>,
    sub: '熟練の職人が一枚一枚丁寧に施工。住宅からホテル・オフィスまで、あらゆる空間に上質な壁紙仕上げをお届けします。',
    primary: { label: 'サービスを見る', href: '#services' },
    secondary: { label: '施工実績', href: '#projects' },
    tint: 'bg-gradient-to-br from-amber-900/40 via-yellow-900/20 to-transparent',
    accent: 'bg-gradient-to-r from-black/75 via-black/50 to-black/20',
    tagColor: '#D4AF37',
    tagLine: '#B8960C',
    btnPrimary: 'bg-[#B8960C] hover:bg-[#9A7D0A]',
    btnSecondary: 'border-[#D4AF37]/70 hover:bg-[#D4AF37]/10 text-[#F5E08A]',
    accentText: 'text-[#D4AF37]',
  },
  {
    seq: 'hero-eikou-s02',
    imageUrl: 'https://public.readdy.ai/ai/img_res/edited_077453af8438d3a14c4b666d5a92420d_f368b36b.jpg',
    tag: 'ボード工事',
    heading: <>確かな施工品質が<br /><span className="text-[#7EC8E3]">空間の価値</span>を<br />高める</>,
    sub: '石膏ボード・岩綿吸音板・化粧板など、多様な素材に対応。天井・壁面の高精度な施工で、快適な空間を実現します。',
    primary: { label: 'ボード工事詳細', href: '/services/board-work' },
    secondary: { label: 'お問い合わせ', href: '#contact' },
    tint: 'bg-gradient-to-br from-slate-800/50 via-zinc-700/25 to-transparent',
    accent: 'bg-gradient-to-r from-black/80 via-slate-900/50 to-black/15',
    tagColor: '#7EC8E3',
    tagLine: '#4A9BB5',
    btnPrimary: 'bg-[#4A9BB5] hover:bg-[#3A7D94]',
    btnSecondary: 'border-[#7EC8E3]/70 hover:bg-[#7EC8E3]/10 text-[#B0E0F0]',
    accentText: 'text-[#7EC8E3]',
  },
  {
    seq: 'hero-eikou-s03',
    imageUrl: 'https://public.readdy.ai/ai/img_res/edited_065d334c6ef2107ecb42f7035f72fc26_e5366efc.jpg',
    tag: '軽鉄下地LGS工事',
    heading: <>強靭な下地が<br /><span className="text-[#8FBC8F]">建物の未来</span>を<br />支え続ける</>,
    sub: '軽量鉄骨（LGS）による高精度な下地施工。耐震性・耐火性に優れた構造で、大規模施設から住宅まで幅広く対応します。',
    primary: { label: 'LGS工事詳細', href: '/services/lgs-work' },
    secondary: { label: '施工実績', href: '#projects' },
    tint: 'bg-gradient-to-br from-stone-800/45 via-neutral-700/20 to-transparent',
    accent: 'bg-gradient-to-r from-black/80 via-stone-900/45 to-black/20',
    tagColor: '#8FBC8F',
    tagLine: '#5A8A5A',
    btnPrimary: 'bg-[#5A8A5A] hover:bg-[#456845]',
    btnSecondary: 'border-[#8FBC8F]/70 hover:bg-[#8FBC8F]/10 text-[#B8D8B8]',
    accentText: 'text-[#8FBC8F]',
  },
  {
    seq: 'hero-eikou-s05',
    imageUrl: 'https://readdy.ai/api/search-image?query=luxurious%20Japanese%20interior%20design%20completed%20renovation%20handover%20ceremony%2C%20elegant%20modern%20living%20room%20with%20warm%20rose%20gold%20copper%20tones%2C%20refined%20wall%20finishing%20craftsmanship%2C%20soft%20ambient%20lighting%2C%20polished%20surfaces%2C%20minimalist%20Japanese%20aesthetic%2C%20high-end%20residential%20interior%20photography%2C%20warm%20cream%20and%20copper%20color%20palette%2C%20ultra%20detailed%20professional%20photography&width=1920&height=1080&seq=hero-eikou-s05-delivery&orientation=landscape',
    tag: '完工引き渡し',
    heading: <>丁寧な仕上げと<br /><span className="text-[#D4956A]">確かな品質保証</span>で<br />安心をお届け</>,
    sub: '施工完了後も安心のアフターサポートを提供。厳格な品質検査と保証制度で、お客様の大切な空間を長期にわたり守ります。',
    primary: { label: '品質保証について', href: '#about' },
    secondary: { label: '無料相談', href: '#contact' },
    tint: 'bg-gradient-to-br from-rose-950/40 via-orange-900/20 to-transparent',
    accent: 'bg-gradient-to-r from-black/80 via-rose-950/35 to-black/20',
    tagColor: '#D4956A',
    tagLine: '#A8683A',
    btnPrimary: 'bg-[#A8683A] hover:bg-[#8A5228]',
    btnSecondary: 'border-[#D4956A]/70 hover:bg-[#D4956A]/10 text-[#F0C4A0]',
    accentText: 'text-[#D4956A]',
  },
];

const STATS = [
  { end: 7, suffix: '+', label: '年の実績', icon: 'ri-award-line' },
  { end: 1200, suffix: '+', label: '施工実績', icon: 'ri-building-2-line' },
  { end: 99, suffix: '%', label: '顧客満足度', icon: 'ri-heart-line' },
  { end: 50, suffix: '+', label: '受賞歴', icon: 'ri-trophy-line' },
];

function useCountUp(end: number, duration = 1800, started = false, animKey = 0) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!started) return;
    setCount(0);
    let startTime: number | null = null;
    let raf: number;
    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      setCount(Math.floor(eased * end));
      if (progress < 1) {
        raf = requestAnimationFrame(step);
      } else {
        setCount(end);
      }
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [end, duration, started, animKey]);
  return count;
}

function StatItem({ stat, started, animKey }: { stat: typeof STATS[0]; started: boolean; animKey: number }) {
  const count = useCountUp(stat.end, 1800, started, animKey);
  const display = stat.end >= 1000 ? count.toLocaleString() : String(count);
  return (
    <div className="flex items-center gap-2 sm:gap-3 sm:gap-4">
      <div className="w-8 h-8 sm:w-10 sm:h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-full border border-[#D4AF37]/30 bg-[#D4AF37]/10 flex-shrink-0">
        <i className={`${stat.icon} text-[#D4AF37] text-base sm:text-lg sm:text-xl`}></i>
      </div>
      <div>
        <div className="text-xl sm:text-3xl sm:text-4xl font-bold text-[#D4AF37]" style={{ fontFamily: "'Noto Serif JP', serif" }}>
          {display}{stat.suffix}
        </div>
        <div className="text-white/80 text-xs sm:text-sm sm:text-base font-semibold tracking-wider mt-0.5">{stat.label}</div>
      </div>
    </div>
  );
}

// 内容动画组件：每次 animKey 变化时重新触发交错淡入
function SlideContent({
  s,
  animKey,
  loaded,
  direction,
}: {
  s: typeof slides[0];
  animKey: number;
  loaded: boolean;
  direction: 'left' | 'right';
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(false);
    const t = setTimeout(() => setVisible(true), 60);
    return () => clearTimeout(t);
  }, [animKey]);

  const baseEnter = loaded && visible;
  // 进入方向：从右切换过来内容从右侧飘入，从左切换过来内容从左侧飘入
  const fromX = direction === 'right' ? '28px' : '-28px';

  const itemStyle = (delay: number): React.CSSProperties => ({
    opacity: baseEnter ? 1 : 0,
    transform: baseEnter ? 'translateY(0) translateX(0)' : `translateY(14px) translateX(${fromX})`,
    transition: `opacity 600ms cubic-bezier(0.22,1,0.36,1) ${delay}ms, transform 600ms cubic-bezier(0.22,1,0.36,1) ${delay}ms`,
  });

  return (
    <div className="max-w-3xl">
      {/* 标签行 */}
      <div className="flex items-center gap-2 sm:gap-3 mb-6 sm:mb-8" style={itemStyle(80)}>
        <div className="w-6 sm:w-8 h-px" style={{ backgroundColor: (s as any).tagLine }}></div>
        <span
          className="text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] font-medium uppercase"
          style={{ color: (s as any).tagColor }}
        >
          Since 2019 — {s.tag}
        </span>
      </div>

      {/* 标题 */}
      <h2
        className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 sm:mb-6"
        style={{ fontFamily: "'Noto Serif JP', serif", ...itemStyle(180) }}
      >
        {s.heading}
      </h2>

      {/* 描述 */}
      <p
        className="text-white/80 text-sm sm:text-base lg:text-lg leading-relaxed mb-8 sm:mb-10 max-w-xl"
        style={itemStyle(300)}
      >
        {s.sub}
      </p>

      {/* 按钮组 */}
      <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4" style={itemStyle(420)}>
        <a
          href={s.primary.href}
          className={`inline-flex items-center justify-center gap-2 sm:gap-3 ${(s as any).btnPrimary} text-white px-6 sm:px-8 py-3 sm:py-4 text-xs sm:text-sm font-medium tracking-wider sm:tracking-widest transition-all cursor-pointer whitespace-nowrap`}
        >
          {s.primary.label}
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </a>
        <a
          href={s.secondary.href}
          className={`inline-flex items-center justify-center gap-2 sm:gap-3 border ${(s as any).btnSecondary} px-6 sm:px-8 py-3 sm:py-4 text-xs sm:text-sm font-medium tracking-wider sm:tracking-widest transition-all cursor-pointer whitespace-nowrap`}
        >
          {s.secondary.label}
        </a>
      </div>
    </div>
  );
}

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [statsStarted, setStatsStarted] = useState(false);
  const [statsAnimKey, setStatsAnimKey] = useState(0);
  // 用于触发内容重新动画
  const [contentAnimKey, setContentAnimKey] = useState(0);
  const [direction, setDirection] = useState<'left' | 'right'>('right');
  const statsRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  // 拖拽状态
  const touchStartX = useRef<number | null>(null);
  const touchStartY = useRef<number | null>(null);
  const isDraggingRef = useRef(false);
  const [dragOffset, setDragOffset] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const el = statsRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStatsStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!statsStarted) return;
    const interval = setInterval(() => {
      setStatsAnimKey(k => k + 1);
    }, 8000);
    return () => clearInterval(interval);
  }, [statsStarted]);

  const goTo = useCallback((index: number, dir?: 'left' | 'right') => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setDragOffset(0);
    setDirection(dir ?? 'right');
    setCurrent(index);
    setContentAnimKey(k => k + 1);
    setTimeout(() => setIsTransitioning(false), 560);
  }, [isTransitioning]);

  const next = useCallback(() => {
    goTo((current + 1) % slides.length, 'right');
  }, [current, goTo]);

  const prev = useCallback(() => {
    goTo((current - 1 + slides.length) % slides.length, 'left');
  }, [current, goTo]);

  // 键盘方向键支持
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft') prev();
      else if (e.key === 'ArrowRight') next();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [prev, next]);

  // 自动播放
  useEffect(() => {
    if (isDragging) return;
    const interval = setInterval(next, 6000);
    return () => clearInterval(interval);
  }, [next, isDragging]);

  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    if (isTransitioning) return;
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
    isDraggingRef.current = false;
    setIsDragging(false);
    setDragOffset(0);
  }, [isTransitioning]);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    if (touchStartX.current === null || touchStartY.current === null) return;
    const deltaX = e.touches[0].clientX - touchStartX.current;
    const deltaY = e.touches[0].clientY - touchStartY.current;

    if (!isDraggingRef.current && Math.abs(deltaX) < Math.abs(deltaY) && Math.abs(deltaY) > 5) {
      touchStartX.current = null;
      return;
    }

    if (Math.abs(deltaX) > 5) {
      isDraggingRef.current = true;
      setIsDragging(true);
    }

    if (isDraggingRef.current) {
      e.preventDefault();
      const width = containerRef.current?.offsetWidth ?? window.innerWidth;
      const isAtStart = current === 0 && deltaX > 0;
      const isAtEnd = current === slides.length - 1 && deltaX < 0;
      const damped = (isAtStart || isAtEnd) ? deltaX * 0.2 : deltaX;
      setDragOffset(Math.max(-width, Math.min(width, damped)));
    }
  }, [current]);

  const handleTouchEnd = useCallback((e: React.TouchEvent) => {
    if (!isDraggingRef.current) {
      touchStartX.current = null;
      touchStartY.current = null;
      return;
    }

    const deltaX = e.changedTouches[0].clientX - (touchStartX.current ?? e.changedTouches[0].clientX);
    const width = containerRef.current?.offsetWidth ?? window.innerWidth;
    const threshold = width * 0.25;

    isDraggingRef.current = false;
    setIsDragging(false);

    if (Math.abs(deltaX) > threshold) {
      if (deltaX < 0 && current < slides.length - 1) {
        goTo(current + 1, 'right');
      } else if (deltaX > 0 && current > 0) {
        goTo(current - 1, 'left');
      } else {
        setIsTransitioning(true);
        setDragOffset(0);
        setTimeout(() => setIsTransitioning(false), 400);
      }
    } else {
      setIsTransitioning(true);
      setDragOffset(0);
      setTimeout(() => setIsTransitioning(false), 400);
    }

    touchStartX.current = null;
    touchStartY.current = null;
  }, [current, goTo]);

  const slide = slides[current];

  const trackOffset = `calc(${-current * 100}vw + ${dragOffset}px)`;
  const trackTransition = isDragging
    ? 'none'
    : 'transform 520ms cubic-bezier(0.77, 0, 0.175, 1)';

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
      ref={containerRef}
      style={{ touchAction: 'pan-y' }}
    >
      {/* 整体滑动轨道 */}
      <div
        className="absolute inset-0 flex"
        style={{
          transform: `translateX(${trackOffset})`,
          transition: trackTransition,
          width: `${slides.length * 100}vw`,
          willChange: 'transform',
        }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {slides.map((s, i) => (
          <div
            key={s.seq}
            className="relative flex-shrink-0 flex items-center"
            style={{ width: '100vw', minHeight: '100vh' }}
          >
            {/* 背景媒体 */}
            {'videoUrl' in s && s.videoUrl ? (
              <video
                src={s.videoUrl}
                className="absolute inset-0 w-full h-full object-cover object-top"
                autoPlay
                muted
                loop
                playsInline
              />
            ) : (
              <img
                src={(s as any).imageUrl}
                alt={`株式会社永恒 ${s.tag}`}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            )}
            <div className={`absolute inset-0 ${(s as any).tint}`}></div>
            <div className={`absolute inset-0 ${(s as any).accent}`}></div>
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50"></div>

            {/* 内容区域 */}
            <div className="relative z-10 w-full px-4 sm:px-6 lg:px-20 py-24 sm:py-28 lg:py-32 pb-52 sm:pb-48 lg:pb-32">
              {i === current ? (
                <SlideContent
                  s={s}
                  animKey={contentAnimKey}
                  loaded={loaded}
                  direction={direction}
                />
              ) : (
                // 非当前幻灯片保持静态内容（不触发动画）
                <div className="max-w-3xl opacity-0">
                  <div className="flex items-center gap-2 sm:gap-3 mb-6 sm:mb-8">
                    <div className="w-6 sm:w-8 h-px"></div>
                    <span className="text-[10px] sm:text-xs">{s.tag}</span>
                  </div>
                  <h2 className="text-4xl font-bold text-white leading-tight mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                    {s.heading}
                  </h2>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* 装飾竖線 */}
      <div className="absolute left-16 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#B8960C]/60 to-transparent hidden lg:block pointer-events-none z-20"></div>

      {/* 左侧居中箭头 */}
      <button
        onClick={prev}
        className="absolute left-4 sm:left-6 top-1/2 -translate-y-1/2 z-30 w-11 h-11 sm:w-13 sm:h-13 flex items-center justify-center border border-white/40 text-white hover:bg-white/20 transition-all cursor-pointer backdrop-blur-sm"
        style={{ borderColor: `${slide.tagColor}70`, background: 'rgba(0,0,0,0.3)' }}
        aria-label="前へ"
      >
        <i className="ri-arrow-left-s-line text-xl sm:text-2xl"></i>
      </button>

      {/* 右侧居中箭头 */}
      <button
        onClick={next}
        className="absolute right-4 sm:right-6 top-1/2 -translate-y-1/2 z-30 w-11 h-11 sm:w-13 sm:h-13 flex items-center justify-center border border-white/40 text-white hover:bg-white/20 transition-all cursor-pointer backdrop-blur-sm"
        style={{ borderColor: `${slide.tagColor}70`, background: 'rgba(0,0,0,0.3)' }}
        aria-label="次へ"
      >
        <i className="ri-arrow-right-s-line text-xl sm:text-2xl"></i>
      </button>

      {/* 右側竖向指示点 */}
      <div className="absolute right-10 top-1/2 -translate-y-1/2 hidden lg:flex flex-col items-center gap-3 z-20">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => goTo(i, i > current ? 'right' : 'left')}
            className="transition-all duration-500 cursor-pointer rounded-full"
            style={{
              width: '6px',
              height: i === current ? '40px' : '16px',
              backgroundColor: i === current ? slide.tagColor : 'rgba(255,255,255,0.3)',
            }}
          />
        ))}
      </div>

      {/* 左下角数字 + 移動端圆点 */}
      <div className="absolute bottom-[108px] xs:bottom-[104px] sm:bottom-[100px] lg:bottom-28 left-4 sm:left-8 lg:left-20 z-20 flex items-center gap-2 sm:gap-3">
        <div className="flex items-baseline gap-1">
          <span
            className="text-lg sm:text-xl font-bold transition-colors duration-700"
            style={{ fontFamily: "'Noto Serif JP', serif", color: slide.tagColor }}
          >
            {String(current + 1).padStart(2, '0')}
          </span>
          <span className="text-white/40 text-xs sm:text-sm">/ {String(slides.length).padStart(2, '0')}</span>
        </div>

        {/* 移動端圆点指示器 */}
        <div className="ml-3 flex items-center gap-2 lg:hidden">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i, i > current ? 'right' : 'left')}
              className="transition-all duration-500 cursor-pointer rounded-full"
              style={{
                width: i === current ? '20px' : '6px',
                height: '6px',
                backgroundColor: i === current ? slide.tagColor : 'rgba(255,255,255,0.4)',
              }}
            />
          ))}
        </div>
      </div>

      {/* 底部統計バー */}
      <div className="absolute bottom-0 left-0 right-0 bg-black/50 backdrop-blur-sm border-t border-white/10 z-20">
        <div className="h-0.5 bg-white/10 w-full">
          <div
            key={current}
            className="h-full"
            style={{
              backgroundColor: slide.tagColor,
              animation: 'progressBar 6s linear forwards',
            }}
          ></div>
        </div>
        <div
          ref={statsRef}
          className="max-w-7xl mx-auto px-4 sm:px-8 py-4 sm:py-5 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6"
        >
          {STATS.map((stat, i) => (
            <StatItem key={i} stat={stat} started={statsStarted} animKey={statsAnimKey} />
          ))}
        </div>
      </div>
    </section>
  );
}
